module.exports = __webpack_public_path__ + "static/img/RocBox.8c3e41c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/RocBox.png
// module id = 8t8A
// module chunks = 1